import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from '@/src/features/app/App';

import '@dark-portal/react-components/dist/index.css';
import './index.scss';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(<App />);
